import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { IoIosArrowDown } from "react-icons/io";
export interface ISingleSelectProps {
  type: 'single-select';
  name: string;
  label?: string;
  labelCls?: string;
  errorMsg?: string;
  errorCls?: string;
  note?: string;
  noteCls?: string;
  buttonCls?: string;
  optionCls?: string;
  rootCls?: string;
  selectedOptionCls?: string;
  openButtonCls?: string;
  id?: string;
  optionsInterface: { isObj: boolean; displayKey?: string };
  options: Array<any>;
  selectedOption: any;
  handleChange?: (name: string, value: any) => void;
}

export default function SingleSelect(props: ISingleSelectProps) {
  const {
    name,
    optionsInterface,
    options,
    selectedOption,
    handleChange,
    label,
    labelCls,
    id,
    rootCls,
    openButtonCls,
    buttonCls,
    errorCls,
    errorMsg,
    note,
    noteCls,
    optionCls,
    selectedOptionCls,
  } = props;

  return (
    <Listbox
      value={selectedOption}
      onChange={(value) => {
        handleChange && handleChange(name, value);
      }}
    >
      {({ open }) => (
        <div className={twMerge(
          clsx({
            '': true,
          }),
          rootCls
        )}>
          {label && label.trim().length > 0 && (
            <Listbox.Label
              htmlFor={id}
              className={twMerge(
                clsx({
                  'mb-2 inline-block text-sm font-Gordita-Regular text-[#333333]':
                    true,
                  'cursor-pointer': id,
                }),
                labelCls
              )}
            >
              {label}
            </Listbox.Label>
          )}
          <div className='relative flex-1'>
            <Listbox.Button
              as="div"
              className={twMerge(
                clsx({
                  'relative w-full min-h-[33px] font-500 md:min-h-[38px] flex truncate border rounded-[6px] border-[#C7C2C2] py-2 px-3 text-left focus:outline-none text-[13px] cursor-pointer justify-between items-center':
                    true,
                  'border-blue-400': open,
                }),
                buttonCls,
                clsx({
                  [String(openButtonCls)]:
                    open && !!openButtonCls && openButtonCls.trim().length > 0,
                })
              )}
            >
              <span className='inline-block md:text-sm text-[12px] font-Gordita-Medium text-[#1c1b1b]'>
                {optionsInterface.isObj
                  ? optionsInterface.displayKey
                    ? selectedOption[optionsInterface.displayKey] ?? ''
                    : ''
                  : selectedOption}
              </span>
              <IoIosArrowDown className={clsx({ "rotate-180": open })} />
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options
                className="absolute mt-1 z-40 max-h-60 w-full overflow-auto max-w-[300px] rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
                id={id}
              >
                {options.map((optn, optnIdx) => (
                  <Listbox.Option
                    as="div"
                    key={`singleSelect-${optnIdx}`}
                    className={twMerge(
                      clsx({
                        'w-full': true,
                      })
                    )}
                    value={optn}
                    disabled={optionsInterface.isObj ? optn.disabled : false}
                  >
                    {({ selected }) => (
                      <div
                        className={twMerge(
                          clsx({
                            'px-3 py-1 mb-1 hover:bg-blue-400 border-b-[1px] border-gray-200 max-w-[300px] hover:text-slate-100 cursor-pointer':
                              true,
                            'text-gray-800 bg-white': !selected,
                            'text-white bg-blue-500': selected,
                          }),
                          optionCls,
                          clsx({
                            [String(selectedOptionCls)]:
                              selected &&
                              !!selectedOptionCls &&
                              selectedOptionCls.trim().length > 0,
                          })
                        )}
                      >
                        {optionsInterface.isObj
                          ? optionsInterface.displayKey
                            ? optn[optionsInterface.displayKey] ?? ''
                            : ''
                          : optn}
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
          {note && note.trim().length > 0 && (
            <p
              className={twMerge(
                clsx({
                  'text-right text-[9px] mb-1 text-gray-700': true,
                }),
                noteCls
              )}
            >
              {note}
            </p>
          )}
          {errorMsg && errorMsg.trim().length > 0 && (
            <p
              className={twMerge(
                clsx({
                  'text-red-400 text-xs mt-1 font-Gordita-Regular': true,
                }),
                errorCls
              )}
            >
              {errorMsg}
            </p>
          )}
        </div>
      )}
    </Listbox>
  );
}
